import type { FC, ReactNode } from "react";
import { cn } from "./utils/cn";

export type BadgeVariant = "neutral" | "success" | "danger" | "info";

export interface BadgeProps {
  /** Color encodes status — this is the legitimate multi-variant exception. */
  variant?: BadgeVariant;
  children: ReactNode;
  className?: string;
}

const variantClasses: Record<BadgeVariant, string> = {
  neutral: "bg-menu/10 text-menu",
  success: "bg-success/10 text-success",
  danger: "bg-danger/10 text-danger",
  info: "bg-secondary/10 text-secondary",
};

/**
 * Status pill. Single shape, color = meaning. Supersedes BetaTag and the
 * inline status pills (subscription status, etc.).
 */
const Badge: FC<BadgeProps> = ({
  variant = "neutral",
  children,
  className,
}) => {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-pill px-2.5 py-1 text-xs font-medium leading-none",
        variantClasses[variant],
        className
      )}
    >
      {children}
    </span>
  );
};

export default Badge;
